import { get } from "lodash";
import { convertToEsgIndexOrNumber } from "common/esg-helpers";
export const validateData = (data) => {
    if (!Array.isArray(data)) {
        return [];
    }
    return data.map((value, index) => {
        const convertedValue = convertToEsgIndexOrNumber(value);
        if (Number.isFinite(convertedValue) || convertedValue === null) {
            return { x: index, y: convertedValue };
        }
        if (value === Object(value) && "y" in value) {
            const convertedValueY = convertToEsgIndexOrNumber(value.y);
            if (Number.isFinite(convertedValueY) || convertedValueY === null) {
                return { x: index, ...value, y: convertedValueY };
            }
            return { x: index, ...value };
        }
        return null;
    }).filter((item) => item);
};
export const formatData = (data, xAxisDisplayName, xAxisType, yAxisDisplayName, yAxisFormatKind) => {
    const formatted = validateData(data)
        .map((dataPoint) => ({ ...dataPoint,
        custom: {
            xAxisDisplayName,
            xAxisType,
            yAxisDisplayName,
            yAxisFormatKind
        } })), values = formatted.map((val) => Number(val.y));
    const max = Math.max(...values), min = Math.min(...values);
    let index = 0;
    for (const value of formatted) {
        if (value.y === max || value.y === min) {
            value.id = `peek${index}`;
            value.radius = value.y === min ? "2" : "3";
            index += 1;
        }
    }
    return formatted;
};
export const getExtreme = (previous, current, comparison) => (previous || previous === 0 ? comparison(previous, current) : current);
export const getExtremes = (colDef, api) => {
    const { field } = colDef || {};
    const result = {};
    if (field) {
        api.forEachNode((node) => {
            const validatedData = validateData(get(node.data, field));
            for (const point of validatedData) {
                result.maxX = getExtreme(result.maxX, point.x, Math.max);
                result.maxY = getExtreme(result.maxY, point.y, Math.max);
                result.minX = getExtreme(result.minX, point.x, Math.min);
                result.minY = getExtreme(result.minY, point.y, Math.min);
            }
        });
    }
    return result;
};
